import React, { useState } from 'react';
import { FaRuler, FaTrash, FaUndo } from 'react-icons/fa';
import { MdClose } from 'react-icons/md';
import '../styles/components/measurement-tools.css';

const Measurement3DTools = ({
  measurementMode,
  onModeChange,
  measurements,
  onClearMeasurements,
  onUndo,
  canUndo
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleDistanceToggle = () => {
    if (measurementMode === 'distance') {
      onModeChange(null);
    } else {
      onModeChange('distance');
    }
  };

  return (
    <div className={`measurement-tools-panel ${isExpanded ? 'expanded' : 'collapsed'}`}>
      <div className="measurement-tools-header">
        <h3 className="measurement-tools-title">
          3D Measurement
        </h3>
        <button
          className="measurement-tools-toggle"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          {isExpanded ? <MdClose /> : <FaRuler />}
        </button>
      </div>

      {isExpanded && (
        <>
          <div className="measurement-tools-buttons">
            <button
              className={`measurement-tool-button measurement-tool-button-single ${measurementMode === 'distance' ? 'active' : ''}`}
              onClick={handleDistanceToggle}
              title="Measure point-to-point distance"
            >
              <span className="measurement-tool-icon"><FaRuler /></span>
              <span className="measurement-tool-label">Point-to-Point Distance</span>
            </button>
          </div>

          {measurementMode === 'distance' && (
            <div className="measurement-instructions">
              <p>Click on two points in the 3D view to measure the distance between them</p>
            </div>
          )}

          {measurements && measurements.length > 0 && (
            <div className="measurement-results">
              <div className="measurement-results-header">
                <h4>Distance Measurements</h4>
                <div className="measurement-actions">
                  {canUndo && (
                    <button
                      className="measurement-action-button"
                      onClick={onUndo}
                      title="Undo last measurement"
                    >
                      <FaUndo />
                    </button>
                  )}
                  <button
                    className="measurement-action-button"
                    onClick={onClearMeasurements}
                    title="Clear all measurements"
                  >
                    <FaTrash />
                  </button>
                </div>
              </div>
              <div className="measurement-results-list">
                {measurements.map((measurement, index) => (
                  <div key={index} className="measurement-result-item">
                    <span className="measurement-result-type">
                      <FaRuler />
                    </span>
                    <span className="measurement-result-value">
                      {measurement.formattedValue}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Measurement3DTools;